<template>
  <v-list-item v-if="!item.children" class="menu-item" :to="item.route || undefined" :exact="isExact(item, siblings)"
    color="primary" link @click="handleItemClick(item)">
    <v-list-item-icon>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <v-list-group v-else class="menu-group" no-action :prepend-icon="item.icon" :group="groupPattern" color="primary">
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-for="(childItem, index) in item.children">
      <v-list-item :key="index" v-if="$check(childItem.permissions)" class="menu-item menu-item--child"
        :to="childItem.route" :exact="isExact(childItem, item.children)" link @click="handleItemClick(childItem)">
        <v-list-item-content>
          <v-list-item-title>{{ childItem.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list-group>
</template>

<script>
import { eventHub } from '@/main'

import router from '../../router'

export default {
  name: 'MenuItem',

  props: {
    item: { type: Object, required: true },
    // Itens do mesmo nível, para decidir quando o destaque precisa ser exato
    siblings: { type: Array, default: () => [] }
  },

  computed: {
    // Abre o grupo automaticamente quando a rota atual pertence a ele
    groupPattern() {
      const routes = (this.item.children || []).map(child => child.route).filter(Boolean)
      if (!routes.length) return undefined
      return routes.map(route => `^${route.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(/|$)`).join('|')
    }
  },

  methods: {
    // "/financeiro" não deve ficar ativo dentro de "/financeiro/motoristas"
    isExact(item, siblings) {
      if (!item.route) return false
      return (siblings || []).some(other => other.route && other.route !== item.route && other.route.startsWith(item.route + '/'))
    },

    handleItemClick(item) {
      if (item.event == 'logout') {
        localStorage.clear();
        router.push("/login");
      } else if (item.event) {
        eventHub.$emit(item.event)
      } else {
        eventHub.$emit('close-menu')
      }
    }
  }
}
</script>
